<script>
import { mapActions } from 'vuex';
import { cloneDeep, result } from 'lodash';
import RbxRemoteCombobox from '@/shared/reybex/RbxRemoteCombobox';
import RbxRemoteComboboxMultiple from '@/shared/reybex/RbxRemoteComboboxMultiple';
import validatorMixin from '@/mixins/validator';
import snackbarMixin from '@/mixins/snackbar';
import RbxDatePicker from '../../../shared/reybex/RbxDatePicker';

export default {
  name: 'NewPrivacyAuditDialog',
  components: {
    RbxRemoteCombobox,
    RbxRemoteComboboxMultiple,
    RbxDatePicker,
  },
  mixins: [snackbarMixin, validatorMixin],
  data() {
    return {
      visible: false,
      isLoading: false,
      rules: {
        name: { required: true },
      },
      baseFormData: {
        name: '',
        auditor: '',
        participants: '',
        startDate: null,
        endDate: null,
        text: '',
      },
      formData: {},
    };
  },
  created() {
    this.formData = cloneDeep(this.baseFormData);
  },
  mounted() {
    this.visible = true;
  },
  beforeDestroy() {
    this.visible = false;
  },
  methods: {
    ...mapActions('privacyAuditDetails', ['savePrivacyAudit']),
    ...mapActions('privacyAuditList', { fetchData: 'fetchPrivacyAuditList' }),
    submit(type) {
      if (!this.validateForm()) return false;

      this.isLoading = true;

      return this.savePrivacyAudit(this.formData)
        .then(({ data }) => {
          this.showSuccessMessage('Das Audit wurde angelegt.');

          if (type === 'new') {
            this.formData = cloneDeep(this.baseFormData);
          } else {
            this.close();

            if (type === 'detail') {
              this.$router.push(`/privacyAudit/${data.id}`);
            }
          }
          this.fetchData();
        })
        .catch(({ response }) => {
          const message = result(response, 'data.data.error', 'Es ist ein Fehler aufgetreten.');
          this.showErrorMessage(message);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    close() {
      this.$emit('cancel');
    },
    onStartDateInput(newDate) {
      this.formData.startDate = newDate;
    },
    onEndDateInput(newDate) {
      this.formData.endDate = newDate;
    },
  },
};
</script>

<template>
  <v-dialog v-model="visible"
            persistent
            max-width="1000px">

    <v-card>
      <v-card-title class="title pa-3">
        Neues Audit
      </v-card-title>

      <v-card-text>
        <v-container grid-list-md class="pa-0">
          <v-layout row wrap>

            <v-flex xs12 md6 py-0>
              <v-text-field
                v-model="formData.name"
                :error-messages="validationErrorMessages.name"
                label="Bezeichnung"
                height="22"
                class="caption"
              />
            </v-flex>

            <v-flex xs12 md6 py-0>
              <v-text-field
                v-model="formData.auditor"
                label="Auditor"
                height="22"
                class="caption"
              />
            </v-flex>

            <v-flex xs12 md6 py-0>
              <v-text-field
                v-model="formData.participants"
                label="Beteiligte"
                height="22"
                class="caption"
              />
            </v-flex>
            <v-flex xs12 md6 py-0/>
            <v-flex xs12 md6 py-0>
              <rbx-date-picker
                label="Beginn"
                :value="formData.startDate"
                @input="onStartDateInput"
              />
            </v-flex>

            <v-flex xs12 md6 py-0>
              <rbx-date-picker label="Ende" :value="formData.endDate" @input="onEndDateInput" />
            </v-flex>

            <v-flex xs12 md6 py-0>
              <v-textarea
                v-model="formData.text"
                label="Text"
                class="caption"
              />
            </v-flex>

          </v-layout>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn @click.native="close"
               color="red"
               flat>
          Schließen
        </v-btn>

        <v-btn @click.native="submit"
               color="blue"
               :loading="isLoading"
               flat>
          Speichern
        </v-btn>

        <v-menu bottom left>
          <v-btn slot="activator" icon>
            <v-icon>expand_more</v-icon>
          </v-btn>

          <v-list>

            <v-list-tile>
              <v-list-tile-title @click="submit('new')">
                Speichern &amp; neu
              </v-list-tile-title>
            </v-list-tile>
            <!-- Does not work.
            <v-list-tile>
              <v-list-tile-title @click="submit('detail')">
                Speichern &amp; Details
              </v-list-tile-title>
            </v-list-tile>
            -->
          </v-list>
        </v-menu>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
